import React, { useState, useEffect, useRef } from 'react';
import cn from "classnames";

const DropdownButton = ({
  buttonName, children
}) => {
  const intention = useRef(false);
  const [ opened, setOpened ] = useState(false);

  useEffect(() => {
    const body = document.body || document.querySelector('body');
    const handler = () => {
      const currentIntention = intention.current;
      if (!currentIntention) {
        setOpened(false);
      }
      intention.current = false;
    };
    body.addEventListener('click', handler);
    return () => {
      body.removeEventListener('click', handler);
    };
  }, []);

  const handleToggle = (event) => {
    event.preventDefault();
    intention.current = true;
    setOpened(!opened);
  };

  return (
    <div className={ cn('dropdown', { 'open': opened }) }>
      <span
        className="dropdown_toggle form-field"
        onClick={ handleToggle }
      >
        { buttonName }
      </span>
      {
        opened &&
        <div className="dropdown_container -corner-right">
          <div className="dropdown_inset">
            <div className="dropdown_content">
              <ul className="selector-list">
                { children }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default DropdownButton;
